import { ClassNameValue, twMerge } from 'tailwind-merge';

type ClassLists = ReadonlyArray<ClassNameValue>;

function dropdownSelectionOptionStyles(...classLists: ClassLists) {
  return twMerge(
    'flex cursor-pointer items-center border-b p-2 text-left last:border-b-0 focus:outline-hidden',
    'ui-active:bg-dark-grey ui-active:text-white',
    'ui-selected:bg-dark-grey ui-selected:text-white',
    'ui-disabled:cursor-not-allowed ui-disabled:bg-light-grey',
    ...classLists,
  );
}

function dropdownSelectionOptionsStyles(...classLists: ClassLists) {
  return twMerge(
    'min-w-(--button-width)',
    'z-100 overflow-hidden border border-black/20 bg-white focus:outline-hidden',
    'flex flex-col items-stretch',
    'data-[anchor~="bottom"]:-mt-px data-[anchor~="bottom"]:rounded-b-md data-[anchor~="bottom"]:shadow-md',
    'data-[anchor~="top"]:mt-px data-[anchor~="top"]:rounded-t-md data-[anchor~="top"]:shadow-t-md',
    'transition-opacity duration-100 ease-in-out data-closed:opacity-0',
    ...classLists,
  );
}

function comboboxInputStyles(...classLists: ClassLists) {
  return twMerge(
    'h-full w-full border border-grey bg-white px-2 py-3 focus:outline-hidden',
    'transition-[border-radius] duration-100 ease-in-out ui-open:rounded-none ui-not-open:rounded-md',
    ...classLists,
  );
}

function comboboxButtonStyles(...classLists: ClassLists) {
  return twMerge(
    'absolute inset-y-0 right-0 h-full',
    'flex items-center justify-end px-3 text-left',
    'cursor-pointer focus:outline-hidden disabled:cursor-default',
    ...classLists,
  );
}

export const comboboxStyles = {
  root: (...classLists: ClassLists) => twMerge('relative', ...classLists),
  input: comboboxInputStyles,
  button: comboboxButtonStyles,
  option: dropdownSelectionOptionStyles,
  options: dropdownSelectionOptionsStyles,
} as const;

function listboxButtonStyles(...classLists: ClassLists) {
  return twMerge(
    'flex h-(--input-height) w-full cursor-pointer items-center gap-2 border border-grey bg-white px-2 py-3 text-left',
    'disabled:cursor-default ui-disabled:bg-background ui-disabled:text-dark-grey',
    'transition-[border-radius] duration-100 ease-in-out ui-open:rounded-none ui-not-open:rounded-md',
    ...classLists,
  );
}

export const listboxStyles = {
  root: twMerge,
  button: listboxButtonStyles,
  option: dropdownSelectionOptionStyles,
  options: dropdownSelectionOptionsStyles,
} as const;

function multiselectListboxOptionStyles(...classLists: ClassLists) {
  return dropdownSelectionOptionStyles(
    'ui-active:[&_svg]:border-white ui-not-selected:[&_svg]:text-transparent',
    // Reset selected style
    'ui-selected:bg-transparent ui-selected:text-inherit',
    ...classLists,
  );
}

export const multiselectListboxStyles = {
  root: twMerge,
  button: listboxButtonStyles,
  option: multiselectListboxOptionStyles,
  options: dropdownSelectionOptionsStyles,
};

export const dropdownMenuStyles = {
  root: twMerge,
  option: dropdownSelectionOptionStyles,
  options: dropdownSelectionOptionsStyles,
};
